import { StepLine } from "./step-line";
import { StepLabel } from "./step-label";
import { StepButton } from "./step-button";
import { StepProps } from "./types";
import styles from "./styles.module.scss";

export const Step = ({
  step,
  label,
  width,
  isActive,
  isPassed,
  isDisabled,
  isLastStep,
  isFirstStep,
  dataTestId,
  buttonContent,
  onClick,
}: StepProps) => {
  const stepDataTestId = `${dataTestId}-step-${step}`;

  return (
    <div
      style={{ width }}
      className={styles.step}
      data-test-id={stepDataTestId}
    >
      <div className={styles["button-container"]}>
        <StepLine
          isHidden={isFirstStep}
          isPassed={isPassed || !isDisabled}
          className={styles["left-line"]}
          dataTestId={`${stepDataTestId}-left`}
        />

        <StepButton
          step={step}
          isActive={isActive}
          isPassed={isPassed}
          isDisabled={isDisabled}
          dataTestId={stepDataTestId}
          buttonContent={buttonContent}
          onClick={onClick}
        />

        <StepLine
          isPassed={isPassed}
          isHidden={isLastStep}
          className={styles["right-line"]}
          dataTestId={`${stepDataTestId}-right`}
        />
      </div>

      <StepLabel
        label={label}
        isActive={isActive}
        dataTestId={stepDataTestId}
      />
    </div>
  );
};
